import type { EnergyBidPtuSnapshot } from '@/features/bidding/types/bidDetail/EnergyBidSnapshot'

/** Total offered watts across all price-ladder steps of a single PTU. */
export function sumPtuOfferedWatts(ptu: EnergyBidPtuSnapshot): number {
  return ptu.steps.reduce((sum, step) => sum + step.offeredVolume.quantity, 0)
}
